import React from "react";
import { Card } from "react-bootstrap";
import { FaCalendar } from "react-icons/fa";
import { LuDot } from "react-icons/lu";
import { BiDotsVerticalRounded } from "react-icons/bi";
import ReactCountryFlag from "react-country-flag";
import getCountryISO2 from "country-iso-3-to-2";
import { Event } from "../../../types/model";
import { formatEventDate } from "../../../utils/eventDateTime";
import "../../../App.css";

interface TopRowCardProps {
	event: Event;
	nearestFutureEvent: Event | null;
	selectedEvent: Event | null;
	handleSelectEvent: (event: Event) => void;
}

const TopRowCard: React.FC<TopRowCardProps> = ({
	event,
	nearestFutureEvent,
	selectedEvent,
	handleSelectEvent,
}) => {
	const rawCountry = (event.country ?? "").toString().trim().toUpperCase();
	const countryCode =
		rawCountry.length === 2 ? rawCountry : getCountryISO2(rawCountry) || "";

	return (
		<Card
			className={`${
				event?._id === selectedEvent?._id ? "text-white" : "text-info"
			} border-0 bg-secondary top-row-card`}
			onClick={() => handleSelectEvent(event)}
			style={{ cursor: "pointer" }}
		>
			<Card.Body className="pb-1 pt-2">
				<Card.Text className="my-0" style={{ fontSize: "0.7rem" }}>
					<FaCalendar className="me-2 mb-1" />
					{formatEventDate(event.date)}
					<span style={{ color: "gray" }}>
						<LuDot className="mb-1 ms-1" />
						{new Date(event.date) > new Date() ? " UPCOMING" : ""}
					</span>
				</Card.Text>
				<Card.Text
					className="my-0"
					style={{
						overflowX: "hidden",
						whiteSpace: "nowrap",
						textOverflow: "ellipsis",
					}}
				>
					<b>{event.series.name}: </b> {event.location}
				</Card.Text>
				<Card.Text style={{ fontSize: "0.7rem" }} className="pb-0 pt-1 mt-0">
					<div className="d-flex flex-row justify-content-between">
						<div className="d-flex flex-row justify-content-start align-items-center">
							{countryCode && (
								<ReactCountryFlag
									countryCode={countryCode}
									svg
									className="mb-1 me-2"
									style={{ width: "1.5em", height: "1.5em" }}
								/>
							)}
							{event.country}
							<BiDotsVerticalRounded className="mx-2 mb-0" />
							{event.sport.name}
						</div>
					</div>
				</Card.Text>
			</Card.Body>
		</Card>
	);
};

export default TopRowCard;
